import { generateItems } from 'domain/common';
import { Cluster } from 'domain/lib';

const { actions, selectors, reducer } = generateItems('Cluster', Cluster);

export { actions, selectors, reducer };
